// @flow

import getCurrentPlanIndex from '../getCurrentPlanIndex';

import { type Plan } from '@zapier/common-utils';

export default (
  plans: Array<Plan>,
  currentPlanId: number,
  isFall2019Pricing: boolean = false
): ?Plan =>
  plans[getCurrentPlanIndex(plans, currentPlanId, isFall2019Pricing)] || null;
